import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TVesselInfo, VESSEL_ONGOING_VOYAGE_SIGNALS, TVesselOngoingVoyageSignalsSliceState } from '../mapTypes';
import { RootState } from '../../../core/store';

const initialState: TVesselOngoingVoyageSignalsSliceState = {
    vesselOngoingVoyageSignalsData: null,
    vesselOngoingVoyageSignalsLoading: false,
    vesselOngoingVoyageSignalsError: null,
};

const vesselOngoingVoyageSignalsSlice = createSlice({
    name: VESSEL_ONGOING_VOYAGE_SIGNALS,
    initialState,
    reducers: {
        emptyVesselOngoingVoyageSignalsAction: (state: TVesselOngoingVoyageSignalsSliceState) => {
            state.vesselOngoingVoyageSignalsData = null;
            state.vesselOngoingVoyageSignalsLoading = false;
            state.vesselOngoingVoyageSignalsError = null;
        },
        getVesselOngoingVoyageSignalsRequestAction: (state: TVesselOngoingVoyageSignalsSliceState, _: PayloadAction<{ imoNumber: number, date: string }>) => {
            state.vesselOngoingVoyageSignalsLoading = true;
            state.vesselOngoingVoyageSignalsError = null;
        },
        getVesselOngoingVoyageSignalsSuccessAction: (
            state: TVesselOngoingVoyageSignalsSliceState,
            { payload: data }: PayloadAction<TVesselInfo>,
        ) => {
            state.vesselOngoingVoyageSignalsLoading = false;
            state.vesselOngoingVoyageSignalsData = data;
            state.vesselOngoingVoyageSignalsError = null;
        },
        getVesselOngoingVoyageSignalsErrorAction: (
            state: TVesselOngoingVoyageSignalsSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            state.vesselOngoingVoyageSignalsData = null;
            state.vesselOngoingVoyageSignalsLoading = false;
            state.vesselOngoingVoyageSignalsError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
    },
});

export const {
    getVesselOngoingVoyageSignalsRequestAction,
    getVesselOngoingVoyageSignalsSuccessAction,
    getVesselOngoingVoyageSignalsErrorAction,
    emptyVesselOngoingVoyageSignalsAction
} = vesselOngoingVoyageSignalsSlice.actions;

export default vesselOngoingVoyageSignalsSlice.reducer;

export const selectVesselOngoingVoyageSignals = (state: RootState) => state.vesselOngoingVoyageSignalsSlice;